module.exports = __webpack_public_path__ + "fonts/e4edea9378ccee493440600733307e93.svg";